/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { USER_FRAGMENT } from '../fragments'

export const BULK_CREATE_USERS = gql`
  mutation BulkCreateUsers($data: [BulkCreateUserRowInput!]!) {
    bulkCreateUsers(data: $data) {
      ...User
    }
  }
  ${USER_FRAGMENT}
`
